import Route from '@ember/routing/route';

export default class AuthenticatedTeamsShowStorageRoute extends Route {}
